(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcControlTestFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$mdToast', 'grcControlService', 'aricEnums'];

    function Controller($rootScope, $scope, $state, $mdToast, grcControlService, aricEnums) {

        $scope.boxModelObjective = $scope.boxModel.TestObjective;

        if (_.isUndefined($scope.boxModel.ControlTestID)) {
            $scope.boxModel.TestMethodologyList = [];
        }

        // Get Control Lookups
        grcControlService.getAllLookups()
            .then(function (lookups) {
                $scope.controlLookups = lookups;
            });

        // Show close control test
        $scope.isShowCloseControlTest = showCloseControlTest();

        function showCloseControlTest() {
            if (!$scope.boxModel.ItemID) return false;
            if (_.isUndefined($scope.boxContext.Control.ControlAssessment)
                || $scope.boxModel.IsClosed
                || !$scope.boxModel._GOV.CanEdit
                || ($scope.boxModel.Control && $scope.boxModel.Control.IsClosed)) return false;

            var validStatuses = [
                aricEnums.controlOwnerStatus.pendingInformation,
                aricEnums.controlOwnerStatus.readyForTesting,
                aricEnums.controlOwnerStatus.testingInProgress];

            return validStatuses.indexOf($scope.boxContext.Control.ControlAssessment.ControlStatusValue) > -1;
        }

        // Show Reset Action?
        $scope.showResetAction = function (form) {
            return $scope.ctxtDir.needSaveChanges;
        };

        // Show Save Action?
        $scope.showSaveAction = function (form) {
            if (!$scope.boxModel.ControlTestID) { return false; }

            if (form.$invalid) { return false; }

            return $scope.ctxtDir.needSaveChanges;
        };

        // Show Add Action?
        $scope.showAddAction = function (form) {
            if ($scope.boxModel.ControlTestID) { return false; }

            if (form.$invalid) { return false; }

            if (!$scope.boxModel.TestMethodologyList || $scope.boxModel.TestMethodologyList.length === 0) {
                return false;
            }

            return $scope.ctxtDir.needSaveChanges;
        };

        // Reset forms
        $scope.reset = function () {
            $scope.isLoading = true;
            $state.reload();
        };

        // Create Control test
        $scope.createControlTest = function () {
            $scope.isLoading = true;
            grcControlService
                .createOrUpdateControlTest($scope.boxModel.ControlID, $scope.boxModel)
                .then(function(addedControlTest) {
                    $scope.pageIsNotDirty();

                    $mdToast.show(
                        $mdToast
                        .simple()
                        .content('Control test has been added')
                        .position('top right')
                        .hideDelay($scope.govNotificationDelay)
                        .action('OK')
                        .theme('primary')
                    );

                    $state.go('control.controlTests.edit', {
                        ControlTestID: addedControlTest.ControlTestID
                    }, {
                        reload: true
                    });
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        };

        // Close Control Test
        $scope.closeControlTest = function() {
            $scope.isLoading = true;
            grcControlService
                .closeControlTest($scope.boxModel)
                .then(function (closedControlTest) {

                    // Need refresh
                    $rootScope.$broadcast('need-refresh');

                    if (_.isObject(closedControlTest) && !_.isUndefined(closedControlTest.ControlTestID)) {
                        // Using assign will trigger Angular's digest cycle to update relative objects
                        _.assign($scope.boxModel, closedControlTest);
                        $scope.readOnly = closedControlTest.IsClosed || $scope.readOnly;
                        $scope.isShowCloseControlTest = showCloseControlTest();
                        $scope.pageIsNotDirty();
                        return;
                    }

                    // ControlTest has been deleted, go to Control page
                    goToControl($scope.boxModel.Control);
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        };

        // Update Control test
        $scope.updateControlTest = function () {
            if ($scope.isSaveActionDisabled()) { return; }
            $scope.isLoading = true;
            grcControlService
                .createOrUpdateControlTest($scope.boxModel.ControlID, $scope.boxModel)
                .then(function (updatedControlTest) {
                    $scope.pageIsNotDirty();

                    _.assign($scope.boxModel, updatedControlTest);
                    $scope.controlTestObjective = $scope.boxModel.TestObjective;

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Your changes have been saved')
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        };

        // Is Save Action Disabled 
        $scope.isSaveActionDisabled = function () {
            return !$scope.boxModel.TestMethodologyList.length;
        };

        // Go To Control
        function goToControl(item) {
            $state.go('control', { ControlID: item.ControlID });
        }
    }
})();